module.exports = __webpack_public_path__ + "ENG_SPT1-Puppy_225002807-c8f0f2eb866972ec8133c5cbe8557267.png";